<template>
  <section class="grid-flex column">
    <div class="box flex-1 w100">
      <div class="box-title">
        <div class="flex middle">
          <div class="flex-1">
            <div class="flex middle between">
              <h3>Produto</h3>
              <div class="button secondary" @click="openModalHistoryCost()">Historico de Custo</div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-content">
        <div class="flex-1">
          <div class="flex middle">
            <div class="flex-1 column">
              <label>Custo do produto:</label>
              <money class="flex input" style="max-width: 250px" v-model="product.cost" v-bind="money"></money>
            </div>
          </div>
          <div class="flex margin-top-l">
            <div class="button primary" @click="updateProduct()">Salvar</div>
            <div
              class="button secondary"
              style="margin-left: 8px"
              @click="updateProductCostToAll()"
            >
              Aplicar em todas variantes
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="box flex-1 w100 margin-top-l" style="margin-left: 0px">
      <div class="box-title">
        <div class="flex column">
          <div class="flex-1 w100">
            <h3>Variantes</h3>
          </div>
          <div class="flex-1 margin-top-l">
            <div class="flex">
              <div class="flex-1">
                <div class="flex ">
                  <div class="flex">
                    <div class="flex-1 column">
                      <label>Custo:</label>
                      <money class="input" v-model="variantCostAll" v-bind="money"></money>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex margin-top-s w100">
              <div class="flex-1">
                <div
                  class="button secondary"
                  @click="updateCostToAllVisible()"
                >
                  Aplicar em todas variantes visiveis
                </div>
              </div>
              <div class="flex-1 flex end">
                <div class="">
                  <input
                    class="input"
                    type="text"
                    v-model="search"
                    placeholder="Buscar variante"
                    />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-content">
        <ul class="list-campaigns">
          <li v-for="(v, index) in renderVariants" :key="index">
            <div class="flex middle">
              <div class="flex-3">
                <div class="flex middle">
                  <div>
                    {{ v.name }}
                  </div>
                  <div class="button secondary" @click="openModalHistoryCost(v.id)" style="margin-left: 16px">Historico de Custo</div>
                </div>
              </div>
              <div class="flex-1">
                <div class="flex middle end row">
                  <div class="flex">
                    <div class="flex-1 column">
                      <label>Custo da variante:</label>
                      <money class="input" v-model="v.cost" v-bind="money"></money>
                    </div>
                  </div>
                  <div class="flex margin-top-m" style="margin-left: 8px">
                    <div
                      class="button primary"
                      @click="updateProductVariant(v)"
                    >
                      Salvar
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <span v-if="isEmpty" class="center-txt margin-top-l">
          <p>Não encontramos variantes para exibir!</p>
        </span>
        <div v-if="loading">
          <content-loading>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
          </content-loading>
        </div>
      </div>
    </div>
    <!-- new list -->
    <cost-historys
      :show="showModalCostHistory"
      :productId="product_id"
      :variantId="selectVariantId"
      @close="
        showModalCostHistory = false;
        selectVariantId = null;
      "
    ></cost-historys>
  </section>

</template>

<script>

import { Money } from 'v-money'


import CostHistorys from './CostHistorys.vue';

import {
  getProduct,
  updateProduct,
  getAllProductVariant,
  updateProductVariant,
  updateProductVariantMassive,
} from "@/services/product";

export default {
  name: "variant-product",
  components: {
    Money,
    CostHistorys,
  },
  props: ["product_id"],
  data() {
    return {
      activeAll: false,
      variants: [],
      product: {
        cost: 0,
      },
      showModalCostHistory: false,
      selectVariantId: null,
      time1: null,
      time2: null,
      variantCostAll: 0,
      variantCostAllStart: null,
      variantCostAllEnd: null,
      search: "",
      searchRender: "",
      loading: false,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      }
    };
  },
  mounted() {
    this.getProduct();
    this.getAllVariantsProduct();
  },
  computed: {
    renderVariants() {
      let _sortVariant = (auxVariants) => {
        auxVariants.sort(function(a, b) {
          return a.id < b.id;
        });
      };

      let auxVariants = this.variants;
      if (!this.searchRender) {
        _sortVariant(auxVariants);
        return auxVariants;
      }

      auxVariants = this.variants.filter((e) => {
        let auxName = e.name.toLowerCase();
        return auxName.includes(this.searchRender.toLowerCase());
      });

      _sortVariant(auxVariants);

      return auxVariants;
    },
    isEmpty() {
      return (
        !this.loading && this.renderVariants && this.renderVariants.length === 0
      );
    },
  },
  watch: {
    search() {
      setTimeout(() => (this.searchRender = this.search), 1000);
    },
  },
  methods: {
    openModalHistoryCost(variantId) {
      this.showModalCostHistory = true
      this.selectVariantId = variantId

    },
    updateProductCostToAll() {
      let self = this;
      let auxVariants = this.variants.map((v) => {
        return {
          id: v.id,
          cost: self.product.cost,
          cost_start_date: self.product.cost_start_date,
          cost_end_date: self.product.cost_end_date,
        };
      });

      this.variants.forEach((v) => {
        v.cost = self.product.cost;
      });

      this.updateProductVariantsAll(auxVariants);
    },
    updateCostToAllVisible() {
      let self = this;
      let auxVariants = this.renderVariants.map((v) => {
        return {
          id: v.id,
          cost: self.variantCostAll,
        };
      });

      this.renderVariants.forEach((v) => {
        v.cost = self.variantCostAll;
      });

      this.updateProductVariantsAll(auxVariants);
    },
    updateProductVariant(variant) {
      let params = {
        variant_id: variant.id,
        cost: variant.cost,
        cost_start_date: variant.cost_start_date,
        cost_end_date: variant.cost_end_date,
      };

      updateProductVariant(this.product_id, params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Variant atualizada com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falhou em atualizar variant",
          });
        });
    },
    updateProductVariantsAll(variantsChange) {
      let params = {
        variants: variantsChange,
      };

      updateProductVariantMassive(this.product_id, params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Variantes editada com sucesso em massa",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falho ao tentar atualizar variantes em massa",
          });
        });
    },
    getAllVariantsProduct() {
      this.loading = true;
      getAllProductVariant(this.product_id)
        .then((result) => {
          this.variants = result.variants;
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Falho buscar variantes",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getProduct() {
      getProduct(this.product_id)
        .then((result) => {
          this.product = result;
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Falho na busca pelo produto",
          });
        });
    },
    updateProduct() {
      let params = {
        cost: this.product.cost,
        cost_start_date: this.product.cost_start_date,
        cost_end_date: this.product.cost_end_date,
      };
      updateProduct(this.product_id, params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Produto atualizado com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falho ao atualizar produto",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.box-title {
  input {
    max-width: 340px;
  }
}

.box-content {
  height: auto;
  max-height: 500px;
  overflow-y: scroll;
}

.list-campaigns {
  li {
    list-style-type: none;
    padding-top: 8px;
    padding-bottom: 8px;
    margin-bottom: 8px;
    border-bottom: 1px solid #c2c2c258;
  }
}


.mx-input {
    height: 48px !important;
}

.fbads {
  color: #3b5998;
}
</style>
